import { Box, keyframes, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1.0); }
`;

const messages =  [
  "Setting things in motion... almost there!",
  "Just putting the final touches...",
  "Hold tight — we’re getting things ready!",
  // "Warming things up for you...",
  // "Everything’s coming together — just a sec!",
  // "Finalizing setup... thanks for your patience.",
  // "Getting your data in place...",
  // "Making sure everything's perfect...",
  // "We’re on it! Loading your workspace now...",
  "Almost ready... prepping your experience."
];

const PageLoader = () => {
    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
      }, 2500); // Change message every 2.5 seconds
  
      return () => clearInterval(interval); // Cleanup on unmount
    }, []);
    return (
        <Box
      sx={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap:1,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[0, 1, 2].map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              animation: `${bounce} 1.4s infinite ease-in-out`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>
       {/* Rotating message */}
      <Typography
        variant="subtitle2"
        sx={{ color: '#1976d2', fontWeight: 500, transition: 'opacity 0.3s' }}
      >
        {/* {messages[messageIndex]} */}
        Loading... please wait a moment
      </Typography>
    </Box>
    )
}

export default PageLoader;


// import { Box } from '@mui/material';

// const PageLoader = () => {
//     return (
//         <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <Box sx={{ width: '30%' }}>
//                 <img src='/images/recruitment-loader.png' alt='Loader' style={{ width: '100%' }} />
//             </Box>
//         </Box>
//     )
// }

// export default PageLoader;